





































































import { Component, Mixins } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import { DatosEmpresa } from "@/shared/dtos/datos_empresa";
import datos_empresaModule from "@/store/modules/datos_empresa-module";
import { RouterNames } from "@/router/routernames";
import { API } from "@/shared/api";

@Component({
  components: {},
})
export default class DatosEmpresaFormulario extends Mixins(
  HelperDinamicallyForm
) {
  public item_pantalla: DatosEmpresa = new DatosEmpresa();

  get documentos() {
    return datos_empresaModule.documentos;
  }

  public async OnCreated() {
    console.log("OnCreated");
    this.ShowLoading();

    const param = this.getparamId();

    if (param.HayParametro) {
      // Cargar empresa específica por ID
      await datos_empresaModule.getDatosEmpresa(param.Parametro);
      this.item_pantalla = datos_empresaModule.datos_empresa;
      console.log(this.item_pantalla);

      // Cargar documentos asociados
      await datos_empresaModule.getDocuments(this.item_pantalla.id);
    } else {
      // Intento de carga por defecto si no hay ID
      await datos_empresaModule.getDatosEmpresas();
      if (
        datos_empresaModule.datos_empresas &&
        datos_empresaModule.datos_empresas.length > 0
      ) {
        this.item_pantalla = datos_empresaModule.datos_empresas[0];
        this.SetManualTypeForm(false);
        await datos_empresaModule.getDocuments(this.item_pantalla.id);
      } else {
        this.item_pantalla = new DatosEmpresa();
        this.SetManualTypeForm(true); // Modo creación
      }
    }

    this.BasicElement = this.item_pantalla;
    this.HideLoading();
  }

  public CreateNameTabs() {
    this.AddTabName("Datos Generales");
    this.AddTabName("Configuración y Seguridad");
    this.AddTabName("Documentos y Logo");
  }

  public CreateFields() {
    console.log("CreateFields");
    // ---- TAB 1: DATOS GENERALES ----
    this.AddFormItemDataDefaultString(
      this.item_pantalla.nombre,
      "Razón Social",
      "nombre",
      100,
      1
    )
      .isRequired()
      .Dimesiones(12, 8, 8);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.nif,
      "NIF / NIE / CIF",
      "nif",
      20,
      1
    )
      .isRequired()
      .Dimesiones(12, 4, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.codigo_cuenta_cotizacion,
      "Cód. Cuenta Cotización (CCC)",
      "codigo_cuenta_cotizacion",
      20,
      1
    ).Dimesiones(12, 6, 6);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.nombre_donde_fichan,
      "Etiqueta de ubicación (Ej: Proyecto, Sede)",
      "nombre_donde_fichan",
      50,
      1
    ).Dimesiones(12, 6, 6);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.notas,
      "Notas internas",
      "notas",
      500,
      1
    )
      .CreateTextArea()
      .Dimesiones(12, 12, 12);

    // ---- TAB 2: CONFIGURACIÓN Y SEGURIDAD ----
    this.AddFormItemDataDefaultBoolean(
      this.item_pantalla.activar_otp,
      "Seguridad: Doble Factor (OTP)",
      "activar_otp",
      2,
      "Seguridad Reforzada (Activada)",
      "Seguridad Estándar (Desactivada)"
    )
      .Dimesiones(12, 12, 12)
      .CrearHint(
        "Al activar el Doble Factor (OTP), los usuarios necesitarán introducir un código generado por una aplicación de autenticación (como Google Authenticator) para acceder."
      );

    this.AddFormItemDataDefaultString(
      this.item_pantalla.name_imagen,
      "Nombre de la imagen / Logo corporativo",
      "name_imagen",
      100,
      2
    )
      .isReadOnly()
      .Dimesiones(12, 6, 6);

    // ---- TAB 3: DOCUMENTOS Y LOGO (SLOT) ----
    this.AddFormItemDataDefaultSlot(
      null,
      "Documentos y Logo",
      "tab-documentos-logo",
      0,
      3
    );
  }

  public Insertar(object: DatosEmpresa) {
    datos_empresaModule.guardarDatosEmpresa(object).then(() => {
      this.AllSaveOk();
      this.$router.push({
        name: RouterNames.datos_empresaformulario_empresa,
        params: { id: datos_empresaModule.datos_empresa.id.toString() },
      });
    });
  }

  public Actualizar(object: DatosEmpresa) {
    // Aseguramos que el ID se mantiene
    object.id = this.item_pantalla.id;
    datos_empresaModule.modificarDatosEmpresa(object).then(() => {
      this.AllSaveOk();
    });
  }

  // --- LOGICA DE FICHEROS ---

  public getImageUrl(name: string) {
    return API.webApiBaseImages + name;
  }

  public formatSize(bytes: number) {
    if (!bytes) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  public async onFileChange(file: File) {
    if (!file) return;

    this.ShowLoading();
    const formData = new FormData();
    formData.append("file", file);

    try {
      await datos_empresaModule.subirDocumento({
        id: this.item_pantalla.id,
        files: formData,
      });
      // Recargamos los datos de la empresa para ver el nuevo logo si aplica
      await datos_empresaModule.getDatosEmpresa(this.item_pantalla.id);
      this.item_pantalla = datos_empresaModule.datos_empresa;
      this.SenToastGuardado();
    } catch (error) {
      console.error(error);
    } finally {
      this.HideLoading();
    }
  }

  public async eliminarDoc(doc: any) {
    if (confirm(`¿Estás seguro de eliminar ${doc.name}?`)) {
      this.ShowLoading();
      try {
        await datos_empresaModule.eliminarDocumento({
          id: this.item_pantalla.id,
          file: doc,
        });
        this.SenToastActualizado();
      } catch (error) {
        console.error(error);
      } finally {
        this.HideLoading();
      }
    }
  }
}
